import { PureComponent } from 'react';

import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import classNames from 'classnames';
import { Button } from 'components/Button/Button';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';

export default class LTEBox extends PureComponent {
  static propTypes = {
    bodyClassName: PropTypes.string,
    bodyComponent: PropTypes.object.isRequired,
    className: PropTypes.string,
    disableHeader: PropTypes.bool,
    footerComponent: PropTypes.object,
    headerBorderColorClass: PropTypes.string,
    headerClassName: PropTypes.string,
    headerComponent: PropTypes.object,
    headerToolsCollapse: PropTypes.bool,
    headerToolsRemove: PropTypes.bool,
    helpComponent: PropTypes.object,
    settingComponent: PropTypes.object,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    titleClassName: PropTypes.string,
  };

  static defaultProps = {
    className: 'box',
    bodyClassName: 'box-body',
    disableHeader: false,
    title: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      showHelp: false,
      showSettings: false,
    };
  }

  getHeader = () => {
    const {
      title,
      headerComponent,
      headerToolsRemove,
      headerToolsCollapse,
      helpComponent,
      settingComponent,
      titleClassName,
    } = this.props;

    if (headerComponent) {
      return headerComponent;
    }
    return (
      <div>
        <h3 className={classNames('box-title', titleClassName)}>{title}</h3>
        <div className='box-tools pull-right'>
          {headerToolsCollapse && (
            <Tooltip content='Collapse'>
              <Button
                variant='tertiary'
                size='xxs'
                className='mr-2'
                data-widget='collapse'
                icon='fa-minus'
              />
            </Tooltip>
          )}
          {headerToolsRemove && (
            <Tooltip content='Remove'>
              <Button
                variant='tertiary'
                size='xxs'
                className='mr-2'
                data-widget='remove'
                icon='fa-xmark'
              />
            </Tooltip>
          )}
          {helpComponent && (
            <Tooltip content='Help'>
              <Button
                variant='tertiary'
                size='xxs'
                className='mr-2'
                onClick={this.handleToggleHelp}
                icon='fa-question'
              />
            </Tooltip>
          )}
          {settingComponent && (
            <Tooltip content='Settings'>
              <Button
                variant='tertiary'
                size='xxs'
                className='mr-2'
                onClick={this.handleToggleSettings}
                icon='fa-gear'
              />
            </Tooltip>
          )}
        </div>
        {helpComponent && this.state.showHelp && (
          <div
            className=''
            style={{
              borderTop: '0px solid #eee',
              marginTop: 10,
              paddingTop: 5,
            }}
          >
            {helpComponent}
          </div>
        )}
      </div>
    );
  };

  handleToggleSettings = handleEvent(() => {
    const { showSettings } = this.state;
    this.setState({ showSettings: !showSettings });
  });

  handleToggleHelp = handleEvent(() => {
    const { showHelp } = this.state;
    this.setState({ showHelp: !showHelp });
  });

  render() {
    const {
      bodyClassName,
      bodyComponent,
      className,
      disableHeader,
      footerComponent,
      headerBorderColorClass,
      headerClassName,
      settingComponent,
    } = this.props;
    return (
      <div className={className}>
        {!disableHeader ? (
          <div
            className={classNames(
              'box-header with-border',
              headerBorderColorClass,
              headerClassName,
            )}
          >
            {this.getHeader()}
          </div>
        ) : null}
        <div className={bodyClassName}>
          {settingComponent && this.state.showSettings && (
            <div
              className=''
              style={{
                borderTop: '0px solid #eee',
                marginTop: 10,
                paddingTop: 5,
              }}
            >
              {settingComponent}
            </div>
          )}
          {bodyComponent}
        </div>
        {footerComponent && <div className='box-footer'>{footerComponent}</div>}
      </div>
    );
  }
}
